module.exports = __webpack_public_path__ + "src/img/select.66dad016.svg";